import React from 'react';
import withIcon from '../utilities/withIcon';

const IconListChecks = () => {
  return (
    <g>
      <path d="M2.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm12.75.75a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5h7.5zM5.766 6.708c.274.26.309.68.097.98l-.07.086-2.84 2.991a.752.752 0 0 1-1.042.047l-.077-.08-1.656-1.96A.755.755 0 0 1 .267 7.71a.752.752 0 0 1 .983.008l.078.08L2.44 9.116l2.262-2.381a.752.752 0 0 1 1.064-.027zm9.484.542a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h7.5zM5.766 1.208c.274.26.309.68.097.98l-.07.086-2.84 2.991a.752.752 0 0 1-1.042.047l-.077-.08-1.656-1.96A.755.755 0 0 1 .267 2.21a.752.752 0 0 1 .983.008l.078.08L2.44 3.616l2.262-2.381a.752.752 0 0 1 1.064-.027zm9.484.542a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h7.5z" />
    </g>
  );
};

export default withIcon(IconListChecks);
